import { __spreadValues } from './chunk-D6FLC3TD.mjs';
import Box from '@mui/material/Box';
import { jsx } from 'react/jsx-runtime';

var FullWidthContainer = (props) => {
  const { sx, children } = props;
  return /* @__PURE__ */ jsx(Box, { sx: __spreadValues({ display: "flex", flexDirection: "column", minHeight: "100vh" }, sx), children });
};

export { FullWidthContainer };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-DGXMD5M6.mjs.map